/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Component, Input } from '@angular/core';
import { IWafPolicy, WafMode } from 'generated-types';
import { WafPolicyItem } from 'ajs/modules/waf/factories/waf-policy/waf-policy.item.factory';

import './waf-policy-custom-preview.component.less';
import { L10nService } from '@vmw/ngx-vip';

import * as l10n from './waf-policy-custom-preview.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * A component for displaying WAF policy custom preview.
 *
 * @author Shanmukha Sarath Kondiparthi
 */
@Component({
    selector: 'waf-policy-custom-preview',
    templateUrl: './waf-policy-custom-preview.component.html',
})
export class WafPolicyCustomPreviewComponent {
    /**
     * Waf Policy Item config
     */
    @Input()
    public config: IWafPolicy;

    /**
     * Flag for editable to be an item or a message item.
     */
    @Input()
    public readonly isItem: boolean;

    /**
     * Waf Policy Item
     */
    @Input()
    public readonly item: WafPolicyItem;

    public readonly wafMode = {
        [WafMode.WAF_MODE_EVALUATION]: WafMode.WAF_MODE_EVALUATION,
        [WafMode.WAF_MODE_DETECTION_ONLY]: WafMode.WAF_MODE_DETECTION_ONLY,
        [WafMode.WAF_MODE_ENFORCEMENT]: WafMode.WAF_MODE_ENFORCEMENT,
    };

    public readonly l10nKeys = l10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }
}
